// src/components/layout/HeaderBar.jsx
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Button,
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  Menu as MenuIcon,
  AccountCircle,
  Logout as LogoutIcon,
  Person as PersonIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const displayNameOnly = (user) =>
  user?.displayName || user?.email?.split('@')[0] || 'Usuario';

const HeaderBar = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
    logout();
    handleMenuClose();
    navigate('/auth/login');
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open sidebar"
          onClick={onMenuClick}
        >
          <MenuIcon />
        </IconButton>

        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          SIGERTRE
        </Typography>

        {/* Navegación principal en el header */}
        <Box sx={{ mr: 1, display: 'flex', gap: 1 }}>
          <Button color="inherit" component={Link} to="/">Inicio</Button>
          <Button color="inherit" component={Link} to="/eventos">Eventos</Button>
          <Button color="inherit" component={Link} to="/resultados">Resultados</Button>
        </Box>

        {/* Menú de usuario */}
{user ? (
  <>
    <IconButton
      edge="end"
      color="inherit"
      onClick={handleMenuOpen}
      aria-controls="profile-menu"
      aria-haspopup="true"
      aria-expanded={Boolean(anchorEl)}
    >
      <AccountCircle />
    </IconButton>
    <Menu
      id="profile-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {/* NOMBRE DEL USUARIO -> ENLACE a /perfil */}
      <MenuItem component={Link} to="/perfil" onClick={handleMenuClose}>
        <ListItemIcon><PersonIcon fontSize="small" /></ListItemIcon>
        <ListItemText primary={displayNameOnly(user)} />
      </MenuItem>

      <Divider />

      {/* MI CUENTA con engrane */}
      <MenuItem component={Link} to="/profile" onClick={handleMenuClose}>
        <ListItemIcon><SettingsIcon fontSize="small" /></ListItemIcon>
        <ListItemText primary="Mi cuenta" />
      </MenuItem>

      <MenuItem onClick={handleLogout}>
        <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
        <ListItemText primary="Cerrar sesión" />
      </MenuItem>
    </Menu>
  </>
) : (
  <>
    <Button color="inherit" component={Link} to="/auth/login">Iniciar Sesión</Button>
    <Button color="inherit" component={Link} to="/auth/register">Registro</Button>
  </>
)}
      </Toolbar>
    </AppBar>
  );
};

export default HeaderBar;
